//Template.js
///////////////////////////////
//React & Material
import { motion } from "framer-motion";
import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
//Component Imports
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import ImageFadeIn from "react-image-fade-in";
//Plugins
import styled from 'styled-components';
import DefaultCard from '../media/cards/default_card.png';
import FourthCard from '../media/cards/fourth_card.png';
import SecondCard from '../media/cards/second_card.png';
import ThirdCard from '../media/cards/third_card.png';


//////////////////////////////
//Styled components
const FullHeightContainer = styled.div`
  height:60vh;
  border-style: solid;
  border-color: #36FFC1;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 767px) {
   display:none;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    display:none;
  }
`
const SocialDeco = styled.p`
font-weight: bold;
font-size: 46px;
line-height: 104.9%;
/* or 48px */
display:inline-block;
color: #36FFC1;
opacity: 0.9;

`
const ProjectSub = styled.h2`
font-size: 22px;
line-height: 104.9%;
/* identical to box height, or 23px */
color: #36FFC1;
width:100%;
text-align:left;

`
const ProjectMain = styled.h1`
font-size: 40px;
line-height: 104.9%;
/* identical to box height, or 42px */
width:100%;
color: #FFFFFF;
text-align:left; 

-webkit-transition: color 0.5s ease-out;
 -moz-transition: color 0.5s ease-out;
 -o-transition: color 0.5s ease-out;
 -ms-transition: color 0.5s ease-out;
 transition: color 0.5s ease-out;
&:hover{
  color: #36FFC1;
}

&:hover ${ProjectSub} {
  display: rgba(255, 255, 255, 0.32);
}

`
const Spacer = styled.div`
  height: ${props => props.height}px;
`
const StackImage = styled(ImageFadeIn)`
  position:absolute;
  z-index: ${props => props.index};
  transform: rotate(${props => props.transform}deg);
  // margin-top:4vh;
`
const CardContainer = styled.div`
  margin-top:4vh;
  position:relative;
`

const TextRow =styled.div`
// transition: width 2s linear 1s;
// background-color:white;
// transition: all 0.4s ease-out 0s;
`

const SocialText = styled.p`
font-weight: bold;
font-size: 46px;
line-height: 104.9%;
/* or 48px */
display:inline-block;
color: rgba(255, 255, 255, 0.32);
opacity: 0.9;
-webkit-transition: color 1s ease-out;
 -moz-transition: color 1s ease-out;
 -o-transition: color 1s ease-out;
 -ms-transition: color 1s ease-out;
 transition: color 1s ease-out;
&:hover{
  color:#36FFC1;
}

&:hover ${SocialDeco} {
  color:white;
}
`


const SocialRow = styled(Row)`
margin-top:10vh;
justify-content: flex-end;
`
//////////////////////////////
//Component class
/**
 * Displays a template component
 */
function MoreWork(props) {

  const [arr,setArr] = useState([DefaultCard,SecondCard,ThirdCard,FourthCard]);
  const [archiveText, setArchiveText] = useState("archive");


  const RenderProject = (sub, main, letter) => {
    return (
      <div>
        <Row>
          <TextRow onMouseEnter={() => updateCards(letter)}>
            <motion.div
            whileHover={{
              x: 10,
              transition: { duration: 0.2,ease: "easeInOut" },
            }}
            >
            <ProjectSub>
              {sub}
            </ProjectSub>
            <ProjectMain>
              {main}
            </ProjectMain>
            </motion.div>
            
          </TextRow>
        </Row>
      </div>
    )
  }

  function removeItem(item){
    const index = arr.indexOf(item);
    if (index > -1) {
      arr.splice(index, 1);
    }
    setArr(JSON.parse(JSON.stringify(arr)));
  }
  const updateCards = (letter) => {

    
    // console.log("Card hovered" + arr[index]);
    // console.log("Previous card" + arr[prevCard]);
    
    console.log("---operation takes place---");
    removeItem(letter);
    
    const newArray = [letter].concat(arr)
    

    // var b = arr[prevCard];
    // arr[prevCard] = arr[index];
    // arr[index] = b;

    // prevCard = index;

    // console.log("Index : " + index);
    // console.log("Previous Card : " + prevCard);

    setArr(JSON.parse(JSON.stringify(newArray)));
    // console.log(arr);
   


    
  }

  const RenderCardStack = () => {
    return (
      <CardContainer>
        <StackImage src={arr[0]} index="4" transform="0" />
        <StackImage src={arr[1]} index="3" transform="8.28" />
        <StackImage src={arr[2]} index="2" transform="14.14" />
        <StackImage src={arr[3]} index="1" transform="18.72" />
      </CardContainer>
    )
  }

  return (
    <FullHeightContainer>
      <Container>
        <Row>
          {/* Project text */}
          <Col>
            {RenderProject("Mobile app design", "Redesigning Pinch", DefaultCard)}
            <Spacer height="70" />
            {RenderProject("Graphical Interface", "gHamming", SecondCard)}
            <Spacer height="70" />
            {RenderProject("FullStack Web app", "Spacey Tracey", ThirdCard)}
            <Spacer height="70" />
            {RenderProject("visual design", "Rene gradee", FourthCard)}
          </Col>
          {/* Cards Section */}
          <Col>
            {RenderCardStack()}
          </Col>
        </Row>
        <SocialRow>
        <SocialText onMouseEnter={()=>setArchiveText("archive coming soon")} onMouseLeave={()=>setArchiveText("archive")}>
          {archiveText}<SocialDeco>.</SocialDeco>
        </SocialText>
      </SocialRow>
      </Container>
    </FullHeightContainer>
  )
}
export default MoreWork;